import React from 'react';
import PropTypes from 'prop-types';
import '../countdown-timer.style.scss';
import classNames from 'classnames';

const TimerInline = ({
  timeStringAndMessaging,
  shouldUseMessagingString,
  shouldIncludeSvg
}) => {

  const timerClasses = classNames('countdown-timer__wrapper', {
    'countdown-timer__wrapper--verbose': shouldUseMessagingString
  });

  return (
    <span className={timerClasses}>
      {shouldIncludeSvg && (
        <img src="https://assets.thdstatic.com/images/v1/clock-black.svg" alt="" />
      )}
      {timeStringAndMessaging.messagingString && shouldUseMessagingString && (
        <span className={timerClasses}>
          {timeStringAndMessaging.messagingString}
        </span>
      )}
      {timeStringAndMessaging.timeString && (
        timeStringAndMessaging.timeString
      )}
    </span>
  );
};

TimerInline.propTypes = {
  shouldUseMessagingString: PropTypes.bool,
  shouldIncludeSvg: PropTypes.bool,
  timeStringAndMessaging: PropTypes.oneOfType([
    PropTypes.shape({
      messagingString: PropTypes.string,
      timeString: PropTypes.string
    }),
    PropTypes.shape({
      messagingString: PropTypes.string,
      timeString: PropTypes.element
    })
  ])
};

TimerInline.defaultProps = {
  shouldUseMessagingString: false,
  shouldIncludeSvg: false,
  timeStringAndMessaging: {
    messagingString: '',
    timeString: ''
  }
};

export default TimerInline;
